import classNames from 'classnames/bind';
import { SelectAirportContext } from 'common/autocomplete/SelectAirportContext';
import { IAirport } from 'common/autocomplete/types';
import { useContext } from 'react';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  airport: IAirport;
  forDeparture: boolean;
  isSubAirport: boolean;
  markMatchedSubstrings(target: string): { __html: string };
}

const Airport = ({
  airport,
  forDeparture,
  isSubAirport,
  markMatchedSubstrings,
}: IProps) => {
  const {
    airportName,
    airportNameEn,
    cityCode,
    cityName,
    cityNameEn,
    countryCode,
    countryName,
    countryNameEn,
    event,
    iataCode,
    isDomestic,
    type,
  } = airport;

  const handleClick = useContext(SelectAirportContext);

  return (
    <li
      className={cx('list_item')}
      data-event-nlog="click"
      data-event-area-code={`${forDeparture ? 'dep' : 'arr'}.auto${isSubAirport ? 'city' : ''}airport`}
      onClick={() =>
        handleClick({ code: iataCode, name: cityName, isDomestic, cityCode })
      }
    >
      <a className={cx('anchor')}>
        <i className={cx('icon')} data-type={type.toUpperCase()} />
        <b className={cx('name')}>
          <span
            className={cx('name_inner')}
            dangerouslySetInnerHTML={markMatchedSubstrings(airportName)}
          />
          &nbsp;
          <span
            className={cx('en')}
            dangerouslySetInnerHTML={markMatchedSubstrings(iataCode)}
          />
        </b>
        {!isSubAirport && (
          <div className={cx('desc')}>
            <em dangerouslySetInnerHTML={markMatchedSubstrings(cityName)} />
            {' / '}
            <em dangerouslySetInnerHTML={markMatchedSubstrings(countryName)} />
          </div>
        )}
        {event && <i className={cx('event')}>이벤트</i>}
      </a>
    </li>
  );
};

export default Airport;
